import { render, staticRenderFns } from "./FieldList.vue?vue&type=template&id=645daf20&scoped=true&"
import script from "./FieldList.vue?vue&type=script&lang=ts&"
export * from "./FieldList.vue?vue&type=script&lang=ts&"
import style0 from "./FieldList.vue?vue&type=style&index=0&id=645daf20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645daf20",
  null
  
)

export default component.exports